<template>
  <div id="timelapse-player">
    <h1>TIMELAPSE PLAYER</h1>

    <div class="container">
      <div class="video-box">
        <video v-show="showVideo" :class="{'fade': showVideo}" :src="url">
        </video>
      </div>
      <div v-show="showVideo" :class="{'fade': showVideo}" class="progress-box">
        <progress id="progress-bar" max='100'></progress>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  data() {
    return {
      showVideo: false,
      video: null,
      progress: null,
      url: '',
      mouseObj: {
        origin: {
          x: 0,
          y: 0
        },
        x: 0,
        y: 0,
        isDown: false
      },
      prevMousePos: {
        x: 0,
        y: 0
      }
    };
  },

  created() {
    this.url = this.$route.query.url;
    if (!this.url) this.$router.push({ name: '404' });
  },

  mounted() {
    const container = document.querySelector('.container');
    this.video = container.querySelector('video');
    this.progress = container.querySelector('#progress-bar');

    if (this.video) {
      this.video.addEventListener('mousemove', this.mouseMove, false);
      this.video.addEventListener('mousedown', this.mouseDown, false);
      this.video.addEventListener('mouseup', this.mouseUp, false);
      this.video.addEventListener('loadedmetadata', this.loadedMetadata, false);
      this.video.addEventListener('timeupdate', this.timeUpdate, false);

      this.video.addEventListener('canplay', () => {
        this.showVideo = true;
      }, false);
    }
  },

  methods: {
    mouseMove(e) {
      /* if (prevMousePos.x === 0) {
      }
      if (prevMousePos.y === 0) {
      } */

      if (e.offsetX > this.mouseObj.x) {
        this.prevMousePos.x = Math.round(this.mouseObj.x); // Math.round(e.offsetX*0.9);
        this.prevMousePos.y = Math.round(this.mouseObj.y); // Math.round(e.offsetY*0.9);
        // console.log('>>>>>');
      } else {
        this.prevMousePos.x = Math.round(this.mouseObj.x);
        this.prevMousePos.y = Math.round(this.mouseObj.y);
        // console.log('<<<<<')
      }

      this.mouseObj.x = e.offsetX;
      this.mouseObj.y = e.offsetY;

      // delta should be between [ 0.2 : 2 ];

      let delta = Number((this.mouseObj.x - this.prevMousePos.x) / 150);

      delta = delta >= 0 ? delta + 0.2 : delta - 0.2;
      delta = delta.toFixed(1) / 1;

      // console.log('delta: ', delta);
      const prevTime = this.video.currentTime;
      if (this.mouseObj.isDown) {
        this.video.currentTime = prevTime + delta;
        // afterEffect(delta);
      }
    },

    mouseUp(e) {
      setTimeout(() => {
        this.mouseObj.isDown = false;
      }, 10);

      console.log('mouseup: ', e.type);
    },

    mouseDown(/* e */) {
      this.mouseObj.origin.x = this.mouseObj.x;
      this.mouseObj.origin.y = this.mouseObj.y;

      this.prevMousePos.x = this.mouseObj.x;
      this.prevMousePos.y = this.mouseObj.y;

      this.mouseObj.isDown = true;
    },

    loadedMetadata() {
      console.log('>>', this.video.duration);

      this.progress.setAttribute('max', this.video.duration);
      this.progress.setAttribute('value', 0.5);

      //
      // let tmp = this.video.duration.toFixed(3);
      // let ms = tmp.split('.');
      // let min = ms[0]/1;
      // let sec = min%60;

      // min = Math.floor(min / 60);
      // min = min<=9 ? '0'+min : ''+min;
      // const time = `${min}:${sec}`;

      // this.duration.innerHTML = time;
    },

    timeUpdate() {
      if (!this.progress.getAttribute('max')) {
        this.progress.setAttribute('max', this.video.duration);
      }

      console.log(this.video.currentTime);
      this.progress.value = this.video.currentTime;
      // const delta = Math.floor((video.currentTime / video.duration) * 100) + '%';
      // this.timelog();
    },

    timelog() {
      // const tmp = this.video.currentTime.toFixed(3);
      // const ms = tmp.split('.');
      // const mlsec = ms[1].substr(0, 2) / 1;
      // let min = ms[0] / 1;
      // const sec = min <= 9 ? `0${min}` : min % 60;

      // min = Math.floor(min / 60);
      // min = min <= 9 ? `0${min}` : `${min}`;
      // const time = `${min}:${sec}:${mlsec}`;

      // timeSpan.innerHTML = time;
    }
  }
};
</script>


<style lang="less" scoped>

.container {
  position: absolute;
  width: 800px;
  height: 475px;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);

  .video-box {
    width: 100%;
    height: 95%;
    background-color: rgba(2, 4, 5, 0.342);
    border-radius: 5px;

    video {
      width: 100%;
      border-radius: 5px;
    }
  }

  .progress-box {
    margin-top: 4px;
    padding: 4px;
    background-color: rgba(68, 70, 70, 0.479);
    border-radius: 4px;

    #progress-bar {
      width: 98%;
      margin-top: 3px;
    }
  }
}


@media only screen and (max-width: 1000px) {
  .container {
    width: 700px;
    height: 400px;
  }
}

@media only screen and (max-width: 710px) {
  .container {
    width: 500px;
    height: 300px;
  }
}

@media only screen and (max-width: 510px) {
  .container {
    width: 100%;
    height: 250px;

    .progress-box {
      padding: 2px;
      border-radius: 3px;

      #progress-bar {
        margin-top: 3px;
      }
    }
  }
}

.fade {
  animation-name: fade;
  animation-duration: 1s;
}

@keyframes fade {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>
